import { storyblokEditable } from "@storyblok/react";
import { customRenderRichText } from "../utils/renderRichText";

const SecurityFeature = ({ blok }) => {
  const backgroundImage = blok.background_image?.filename || "";

  const paragraphContent = blok.paragraph
    ? customRenderRichText(blok.paragraph)
    : null;

  const sectionStyle = backgroundImage
    ? {
        // 1st layer is gradient, 2nd layer is image
        backgroundImage: `linear-gradient(
          to bottom,
          rgba(1, 53, 156, 0.6), 
          rgba(0, 11, 63, 0.85)   
        ), url(${backgroundImage})`,
        // gradient covers the whole component
        backgroundSize: "cover, contain",
        backgroundPosition: "center, center",
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundColor: "#01359C",
      }
    : {
        backgroundImage: `linear-gradient(
          to bottom,
          rgba(1, 53, 156, 0.6),
          rgba(0, 11, 63, 0.85)
        )`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#01359C",
      };

  return (
    <section
      {...storyblokEditable(blok)}
      className="relative w-full text-white min-h-[480px] md:min-h-[600px]"
      style={sectionStyle}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-24 flex flex-col items-center md:items-start">
        {/* Text column */}
        <div className="w-full md:w-1/2">
          {blok.title && (
            <h2 className="font-semibold text-[36px] leading-tight mb-6">
              {blok.title}
            </h2>
          )}

          {paragraphContent && (
            <div className="text-base md:text-lg leading-relaxed mb-6 text-gray-100">
              {paragraphContent}
            </div>
          )}

          {blok.subheading && (
            <p className="text-lg font-semibold mb-8">
              {blok.subheading}
            </p>
          )}

          {blok.button_text && (
            <a
              href={blok.button_link?.url || "#"}
              className="inline-flex items-center justify-center rounded-full px-6 h-10 text-sm font-medium"
              style={{ backgroundColor: "#1371DC" }}
            >
              {blok.button_icon?.filename && (
                <img
                  src={blok.button_icon.filename}
                  alt={blok.button_icon.alt || ""}
                  className="w-[19px] h-[14px] mr-2"
                />
              )}
              <span>{blok.button_text}</span>
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default SecurityFeature;
